import { mapState } from "vuex";
export const serviceIndexMixins = {
  computed: {
    serviceTopBarList() {
      let topbarList = [
        {
          name: "服务管理",
          isActive: false,
          path: "/service",
          childrenPath: ["/service/edit"],
          icon:require("@/assets/img/menuIcons/icon-service.png")
        },
        {
          name: "分类管理",
          isActive: false,
          path: "/service/tag",
          icon:require("@/assets/img/menuIcons/icon-servicetag.png")
        },
        {
          name: "改价管理",
          isActive: false,
          path: "/service/priceChangeManage",
          icon:require("@/assets/img/menuIcons/icon-servicepriceChangeManage.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
